<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Listado de Acreditaciones</b-card-header>
      <b-card-body>
        <div style="border: 1px solid #d6d4d4;">
          <div class="row" style="padding-left:10px;padding-right:10px;padding-bottom:20px">
            <div class="col-sm-4">
              <label>Fecha desde</label>
              <KitsDateTime v-model="model.fechaDesde" :currentValue="model.fechaDesde" />
            </div>
            <div class="col-sm-4">
              <label>Fecha hasta</label>
              <KitsDateTime v-model="model.fechaHasta" :currentValue="model.fechaHasta" />
            </div>
          </div>
          <div class="row" style="padding-left:10px;padding-bottom:20px">

            <div class="col-sm-4">
              <label>Medio de pago</label>
              <KitsCombo
                v-model="model.paymentMethodID"
                v-bind:items="model.paymentMethods"
                propertyName="Name"
                propertyID="EntityID"
                :todos="true"
                nullText="Todos"
              ></KitsCombo>
            </div>

            <div class="col-sm-4">
              <label>Operación</label>
              <KitsCombo
                v-model="model.operationTypeID"
                v-bind:items="model.operationTypes"
                propertyName="Name"
                propertyID="EntityID"
                :todos="true"
                nullText="Todos"
              ></KitsCombo>
            </div>
          </div>
          <div class="row" style="padding-left:10px;padding-right:10px">
            <div class="col-sm-4">
              <label>Importe desde</label>
              <base-input v-model="model.importeDesde"></base-input>
            </div>
            <div class="col-sm-4">
              <label>Importe hasta</label>
              <base-input v-model="model.importeHasta"></base-input>
            </div>
            <div class="col-sm-2 text-right" style="padding-top:32px">
              <filter-button @click="getListadoOperaciones" style="height:40px;width:130px;"></filter-button>
            </div>

            <div
              class="col-sm-2 text-right"
              style="padding-right:50px;padding-top:32px"
              v-if="model.operations.length"
            >
              <b-button class="btn btn-success" @click="GetOperationsExport()">
                <i class="fa fa-fw fa-file-excel"></i>Exportar
              </b-button>
            </div>
          </div>

          <div
            v-show="model.sucursalesLength > 0"
            class="row"
            style="padding-left:10px;padding-right:10px;margin-bottom:20px"
          >
            <div class="col-sm-4">
              <label>Sucursal</label>
              <br />
              <KitsCombo
                v-model="model.sucursal"
                v-bind:items="model.sucursales"
                propertyName="Name"
                propertyID="EntityID"
                :todos="true"
              ></KitsCombo>
            </div>

            <div class="col-sm-4">
              <label>Cajero</label>
              <br />
              <KitsCombo
                v-model="model.cajero"
                v-bind:items="model.cajeros"
                propertyName="Name"
                propertyID="CashierID"
                :todos="true"
                :disabled="isAllSucursalSelected()"
              ></KitsCombo>
            </div>
          </div>
        </div>

        <div class="row" style="padding-bottom:30px"></div>

        <div v-if="this.model.operationLenght == 0" class="text-center">
          <div>No se encontraron registros</div>
          <img src="/img/ic_no_resultado.png" style="width: 200px;" />
        </div>
        <div v-else>
          <div style="width: 100%; overflow-x:auto;">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">
                    <strong>Nro de operación</strong>
                  </th>
                  <th scope="col">
                    <strong>Medio de pago</strong>
                  </th>
                  <th scope="col">
                    <strong>Cuotas</strong>
                  </th>
                  <th scope="col">
                    <strong>Marca tarjeta</strong>
                  </th>
                  <th scope="col">
                    <strong>Nro de serie</strong>
                  </th>
                  <th scope="col">
                    <strong>Importe</strong>
                  </th>
                  <th scope="col">
                    <strong>Sucursal</strong>
                  </th>
                  <th scope="col">
                    <strong>Cajero</strong>
                  </th>
                  <th scope="col">
                    <strong>Comisión operación</strong>
                  </th>
                  <th scope="col">
                    <strong>Comisión por adelanto</strong>
                  </th>
                  <th scope="col">
                    <strong>Importe acreditado</strong>
                  </th>
                  <th scope="col">
                    <strong>Operación adelantada</strong>
                  </th>
                  <th scope="col">
                    <strong>Fecha estado</strong>
                  </th>
                  <th scope="col">
                    <strong>Fecha de cobro</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in this.model.operations"
                  v-bind:key="item.Id"
                  style="border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
                >
                  <td class="text-center">{{item.TransactionPlatformID}}</td>
                  <td class="text-center">{{item.PaymentMethodName}}</td>
                  <td class="text-center">{{item.Dues}}</td>
                  <td class="text-center">{{item.BrandCard}}</td>
                  <td class="text-center">{{item.DNIPayer}}</td>
                  <td class="text-center">{{item.FormattedTotalAmount}}</td>
                  <td class="text-center">{{item.BranchBoxName}}</td>
                  <td class="text-center">{{item.CashierName}}</td>
                  <td class="text-center">{{item.FormattedCommissionAmount}}</td>
                  <td class="text-center">{{item.FormattedCommissionAdvanceAmount}}</td>
                  <td class="text-center">{{item.NetAmount}}</td>
                  <td class="text-center">{{item.IsAdvanced}}</td>
                  <td class="text-center">{{item.FormattedLastStateDate}}</td>
                  <td class="text-center">{{item.FormattedTransactionDate}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="row"
            style="border: 1px solid #d6d4d4;margin-top: 30px"
          >
            <div class="col-md-2 text-center col-total" style="padding-top:35px">
              <label>Operaciones Acreditadas</label>
            </div>
            <div class="col-md-3 text-center col-total">
              <label>Cantidad</label>
              <input
                type="text"
                class="form-control text-right"
                readonly
                v-model="model.operationsCount"
              />
            </div>
            <div class="col-md-3 text-center col-total">
              <label>Importe Acreditado</label>
              <input
                type="text"
                class="form-control text-right"
                readonly
                v-model="model.formattedTotalAmount"
              />
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped>
th {
  font-weight: bold;
  background-color: gainsboro;
  font-size: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
}
td {
  font-size: 15px;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import datetimeHelpers from "@/helpers/datetimeHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import confirmHelper from "@/helpers/confirmHelpers";
import KitsDate from "@/components/KitsDate";
import KitsDateTime from "@/components/KitsDateTime";
import KitsCombo from "@/components/KitsCombo";
import fileHelpers from "@/helpers/fileHelpers";
import DateTime from "luxon/src/datetime.js";

// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

export default {
  components: { KitsDate, KitsDateTime, KitsCombo },
  data() {
    return {
      model: {
        fechaDesde: "",
        fechaHasta: "",
        importeDesde: "",
        importeHasta: "",
        sucursal: null,
        cajero: null,
        sucursales: [],
        cajeros: [],
        paymentMethods: [],
        paymentMethodID: 0,
        states: [],
        operationTypes: [],
        operationTypeID: 0,
        isAdvanced: null,
        operations: [],
        operationLenght: 0,
        operationsCount: 0,
        formattedTotalAmount: "",
        sucursalesLength: 0
      }
    };
  },
  methods: {
    isAllSucursalSelected() {
      let context = this;

      if (context.model.sucursal == null || isNaN(context.model.sucursal)) {
        return true;
      } else {
        return false;
      }
    },
    getCashiersByBranchOffice() {
      let context = this;
      
      context.model.cajeros = [];

      if (context.isAllSucursalSelected() == false) {
        axiosHelpers.axiosGet(
          "Commerce/GetCashiersByBranchOffice",
          { BranchOfficeID: context.model.sucursal },
          context,
          function(data) {
            context.model.cajeros = data.ResponseVM.Items;
          }
        );
      } else {
        context.model.cajero = null;
      }
    },
    GetOperationsExport() {
      let context = this;

      var items = [];
      context.model.operations.forEach(x => {
        var operation = {
          TransactionPlatformID: x.TransactionPlatformID,
          PaymentMethodName: x.PaymentMethodName,
          Dues: x.Dues,
          BrandCard: x.BrandCard,
          DNIPayer: x.DNIPayer,
          TotalAmount: x.TotalAmount,
          BranchBoxName: x.BranchBoxName,
          CashierName: x.CashierName,
          CommissionAmount: x.CommissionAmount,
          CommissionAdvanceAmount: x.CommissionAdvanceAmount,
          State: x.State,
          Advanced: x.IsAdvanced,

          FormattedLastStateDateHour: x.FormattedLastStateDate,
          FormattedTransactionDateHour: x.FormattedTransactionDate,

          NetAmount: x.CreditedAmount
        };
        items.push(operation);
      });
      axiosHelpers.axiosPost(
        "OperationsFintouch/GetAcreditedOperationsExport",
        { Items: items },
        this,
        function(response) {
          var contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileHelpers.downloadFile(
            context,
            response.ResponseVM.FileContentBase64,
            response.ResponseVM.FileName,
            contentType
          );
        }
      );
    },
    getFormattedYesNo(opcion) {
      if (opcion == true) return "Si";
      else return "No";
    },
    goBack() {
      this.$router.push("SmartPost");
    },
    getListadoOperaciones() {
      let context = this;

      if (context.model.operationTypeID == 0) context.model.isAdvanced = null;
      else if (context.model.operationTypeID == 1)
        context.model.isAdvanced = true;
      else if (context.model.operationTypeID == 2)
        context.model.isAdvanced = false;

      if (context.model.paymentMethodID == 0)
        context.model.paymentMethodID = null;

      axiosHelpers.axiosGet(
        "OperationsFintouch/GetAcreditationsList",
        {
          DateFrom: context.model.fechaDesde,
          DateTo: context.model.fechaHasta,
          AmountFrom: context.model.importeDesde,
          AmountTo: context.model.importeHasta,
          OperationAdvanced: context.model.isAdvanced,
          PaymentMethodID: context.model.paymentMethodID,
          BranchOfficeID: context.model.sucursal,
          CashierID: context.model.cajero
        },
        context,
        function(response) {
          if (context.model.paymentMethods.length == 0)
            context.model.paymentMethods =
              response.ResponseVM.TypePaymentMethod;
          if (context.model.states.length == 0)
            context.model.states = response.ResponseVM.TypeState;
          if (context.model.operationTypes.length == 0)
            context.model.operationTypes = response.ResponseVM.TypeOperation;
          if (context.model.sucursales.length == 0)
            context.model.sucursales = response.ResponseVM.BranchOffices;
          if (context.model.cajeros.length == 0)
            context.model.cajeros = response.ResponseVM.Cashiers;

          if (context.isAllSucursalSelected()) {
            context.model.cajeros = [];
          }

          context.model.sucursalesLength = context.model.sucursales.length;

          context.model.operationsCount =
            response.ResponseVM.OperationsCount;
          context.model.formattedTotalAmount =
            response.ResponseVM.FormattedTotalAmount;

          context.model.operations = [];
          var i = 1;
          response.ResponseVM.Items.forEach(x => {
            var operation = {
              Id: i,
              TransactionPlatformID: x.TransactionPlatformID,
              PaymentMethodName: x.PaymentMethodName,
              Dues: x.Dues,
              BrandCard: x.BrandCard,
              DNIPayer: x.DNIPayer,
              TotalAmount: x.TotalAmount,
              FormattedTotalAmount: x.FormattedTotalAmount,
              BranchBoxName: x.BranchBoxName,
              CashierName: x.CashierName,
              CommissionAmount: x.CommissionAmount,
              FormattedCommissionAmount: x.FormattedCommissionAmount,
              CommissionAdvanceAmount: x.CommissionAdvanceAmount,
              FormattedCommissionAdvanceAmount:
                x.FormattedCommissionAdvanceAmount,
              PendingReturnAmount: x.PendingReturnAmount,
              FormattedPendingReturnAmount: x.FormattedPendingReturnAmount,
              State: x.State,
              IsAdvanced: context.getFormattedYesNo(x.IsAdvanced),

              FormattedLastStateDate: x.FormattedLastStateDateHour,
              FormattedTransactionDate: x.FormattedTransactionDateHour,
              CreditedAmount: x.CreditedAmount,
              NetAmount: x.FormattedCreditedAmount
            };
            i++;
            context.model.operations.push(operation);
          });
          context.model.operationLenght = context.model.operations.length;
        }
      );
    },
    getDatetimeToday() {
      var dt = DateTime.local();
      var ret = DateTime.local(dt.year, dt.month, dt.day, 0, 0);
      return ret.toString();
    }
  },
  mounted: function() {
    this.model.fechaDesde = this.getDatetimeToday();
    this.model.fechaHasta = datetimeHelpers.getNextDay();
    this.getListadoOperaciones();
  },
  watch: {
    "model.sucursal": function(newValue, oldValue) {
      this.getCashiersByBranchOffice();
    }
  }
};
</script>